import WarehouseHeader from "./components/WarehouseHeader";
import WarehouseListWithFilter from "./components/WarehouseListWithFilter";
import WarehouseCostSummary from "./components/WarehouseCostSummary";
import WarehouseSummaryCostGraph from "./components/WarehouseSummaryCostGraph";
import { Card, CardContent } from "@altimateai/lego";
import { Stack } from "@altimateai/lego";
import WarehouseDateRange from "./components/WarehouseDateRange";

const Warehouses = () => {
  return (
    <div>
      <WarehouseHeader />
      <Card>
        <CardContent className="!al-p-4">
          <Stack gap={"md"} align={"center"} justify="between" className="al-mb-2">
            <Stack>
              <WarehouseDateRange />
              <div id="filter-container" />
            </Stack>
            <Stack>
              <div id="saved-filters-container" />
            </Stack>
          </Stack>
          <WarehouseCostSummary />
          <WarehouseSummaryCostGraph />
          <WarehouseListWithFilter />
        </CardContent>
      </Card>
    </div>
  );
};

export { Warehouses };
